
import {
  computed, defineComponent, ref,
} from 'vue';
import { NETWORK_CONTACT_TYPES } from '@/types/enums';
import { useSpacesStore } from '../store/spacesStore';
import SpacesUser from './SpacesUser.vue';
import SpacesGroup from '@/modules/spaces/components/SpacesGroup.vue';
import SpacesUserTransition from './SpacesUserTransition.vue';
import AppItemWrapper from '@/components/AppItemWrapper.vue';
import AppSkeletonContact from '@/components/skeletons/AppSkeletonContact.vue';
import { IConversationItemGroupList, IGroupData, IRequestSpaces } from '@/types/interfaces';

export default defineComponent({
  props: {
    outgoingList: { type: Array as () => IRequestSpaces[], required: true },
    skeleton: { type: Boolean, default: false },
    customTitle: { type: String, default: '' },
  },
  components: {
    SpacesUser,
    SpacesGroup,
    SpacesUserTransition,
    AppItemWrapper,
    AppSkeletonContact,
  },
  setup(props, { emit }) {
    const spacesStore = useSpacesStore();
    const isGroupInfo = ref(false);
    const showAll = ref(false);
    const toShowViewAll = computed(() => props.outgoingList.length > 5);

    const outgoing = computed(() => {
      if (!showAll.value) {
        return props.outgoingList.length <= 5 ? props.outgoingList : props.outgoingList.slice(0, 5);
      }
      return props.outgoingList;
    });

    function openGroupInfo(group: IGroupData) {
      emit('open-group', group);
    }

    return {
      spacesStore,
      toShowViewAll,
      outgoing,
      NETWORK_CONTACT_TYPES,
      showAll,
      isGroupInfo,
      openGroupInfo,
    };
  },
});
